import React from "react";
import "./Teachers.css";

export default function Teachers() {
  return (
    <div className="teachers">
      <h3>Our Team</h3>
      <h1>Expert Teachers</h1>
      <div className="grid gridFr container">
        <div
          className="con"
          style={{
            backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255,0) 5%, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.9)), url(${"https://images.unsplash.com/flagged/photo-1567194974473-c866a1ba88d5?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=334&q=80"})`,
            backgroundBlendMode: "multiply",
            backgroundSize: "fit",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
          }}
        >
          <div>
            <h3>Dr. Arron Marin</h3>
            <p>Principle</p>
          </div>
        </div>
        <div
          className="con"
          style={{
            backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0) 5%, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.9)), url(${"https://radiustheme.com/demo/wordpress/themes/roofix/wp-content/uploads/2021/02/team_05.jpg"})`,
            backgroundBlendMode: "multiply",
            backgroundSize: "fit",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
          }}
        >
          <div>
            <h3>Harveni Loiz</h3>
            <p>Teacher </p>
          </div>
        </div>
        <div
          className="con"
          style={{
            backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255,0) 5%, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.9)), url(${"https://radiustheme.com/demo/wordpress/themes/roofix/wp-content/uploads/2021/02/team_01.jpg"})`,
            backgroundBlendMode: "multiply",
            backgroundSize: "fit",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
          }}
        >
          <div>
            <h3>Harrison Harvey</h3>
            <p>Teacher </p>
          </div>
        </div>
        <div
          className="con"
          style={{
            backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0) 5%, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.9)), url(${"https://images.unsplash.com/photo-1560250097-0b93528c311a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80"})`,
            backgroundBlendMode: "multiply",
            backgroundSize: "fit",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
          }}
        >
          <div>
            <h3>Harrison Harvey</h3>
            <p>Teacher </p>
          </div>
        </div>
      </div>
    </div>
  );
}
